import { render, staticRenderFns } from "./ChatMessageStatus.vue?vue&type=template&id=604269b7&scoped=true&"
import script from "./ChatMessageStatus.vue?vue&type=script&lang=js&"
export * from "./ChatMessageStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageStatus.vue?vue&type=style&index=0&id=604269b7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604269b7",
  null
  
)

export default component.exports